import { DSNCAudio } from 'shared-definitions/types'
import { ApiComponentAudio } from 'data-source/types.wp'

export function ncAudio(input: ApiComponentAudio): DSNCAudio {
  return {
    resource: 'nc-audio',
    link: input.src,
  }
}
